import { translate } from "app/filters/i18nFilter";

import type { IFilter } from "./types";

export const FILTERS: IFilter[] = [
    {
        key: "all",
        get text() {
            return translate("global.all");
        },
    },
    {
        key: "my",
        get text() {
            return translate("llm.homepage.table.filters.item.personal");
        },
    },
    {
        key: "shared",
        get text() {
            return translate("llm.homepage.table.filters.item.shared");
        },
    },
    {
        key: "demo",
        get text() {
            return translate("llm.homepage.table.filters.item.demo");
        },
    },
];
